var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 373.23 125.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91,66,.06,65.88a62.68,62.68,0,0,0,57.77,59.31l.18-1.3C29,120,6.33,95.45,3.91,66Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.66,5.57a57.13,57.13,0,0,1,5,114A67.75,67.75,0,0,0,48,75.91,67.77,67.77,0,0,0,5.94,56,57.13,57.13,0,0,1,62.66,5.57m0-5.57A62.69,62.69,0,0,0,0,61.32,62.69,62.69,0,0,1,62.2,124c0,.46,0,.92,0,1.38h.5A62.7,62.7,0,1,0,62.66,0Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.64,84.37C80.77,78,59.88,53.74,59.88,25.08a57,57,0,0,1,1.51-13H60a1.85,1.85,0,0,0-1.82,1.49,59.14,59.14,0,0,0-1.13,11.52,60,60,0,0,0,51.55,59.31Z",
    fill: "#b0ca31"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 167.01,
    y: 22.07,
    width: 2.26,
    height: 81.25,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220.2,24.52a9.15,9.15,0,1,1,0,18.3h-7.93v13h-5.49V24.52ZM212.27,26v15.4h3.85a7.7,7.7,0,0,0,0-15.4Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M247.83,33.26,238.4,55.85h-1.63L250,24.52l13.6,31.33h-6Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M276.92,24.52H288C296.65,24.52,303,31,303,40.18S296.65,55.85,288,55.85H276.92ZM282.4,26v28.4h3.45c7.83,0,11.59-7,11.59-14.18S293.63,26,285.85,26Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M317.46,24.52h20.87V26H323V37.55h13.34V39H323V54.36h15.36v1.49H317.46Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M357.75,24.52V54.36h15.33v1.49H352.24V24.52Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M206.78,70.68h5.51v13h12.07v-13h5.56V102h-5.56V85.2H212.29V102h-5.51Z",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M268.25,75.27a15.66,15.66,0,1,1-22.15,0A15.67,15.67,0,0,1,268.25,75.27Zm-11.11-3.11c-5.6-.06-10.11,6.38-10.09,14.19,0,4.74,1.64,9,4.2,11.55a8.46,8.46,0,0,0,5.93,2.64c5.64,0,10.16-6.37,10.12-14.19,0-4.74-1.64-9-4.2-11.55A8.3,8.3,0,0,0,257.14,72.16Z",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M284.12,70.68h5.51V92.22c0,3.8,3.19,6,7.07,6s7.25-1.82,7.25-6V70.68h1.44v21.9c0,5.89-4.34,9.43-10.61,9.43s-10.61-3.76-10.66-9.43Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M328,70.68a19.61,19.61,0,0,1,10.25,2.64l-.62,1.17A20,20,0,0,0,328.23,72c-2.4,0-5.49.7-6.47,3.21-.72,1.85.22,4.17,3.52,5.44l7.93,3c6.9,2.59,8.91,7.67,7.28,11.74C339.15,99,334.91,102,328.56,102c-4.67,0-9.41-2.06-11.9-5.34l1-.89a13.92,13.92,0,0,0,10.85,4.8c4,0,6.52-1.82,7.33-4.12,1-2.74-.45-6.09-4.69-7.72L323,85.61c-5-1.92-6.85-5.61-6.13-8.75C317.69,73.51,321.57,70.68,328,70.68Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M352.37,70.68h20.86v1.44H357.88V83.71h13.34V85.2H357.88v15.33h15.35V102H352.37Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.85479d54dd43870464305c9f9e4b04c8.svg";
export { ForwardRef as ReactComponent };